/* eslint-disable */
import React from 'react';
import GenericUploadStatusBar from './GenericUploadStatusBar';
import ReactDOM from 'react-dom';

const beforeUnload = (e) => {
	e.preventDefault();
	return '';
};

const uploadData = (config: {
	heading: string,
	data: any[],
	batchFunction: (data: any) => Promise<{
		isSuccess: boolean; failures?: any[]; errorMessage?: string
	}>,
	failureArrayKeysToShow: string[];
	isSingleApi?: boolean;
	onAllBatchesComplete?: () => Promise<any>;
	dataHeaders?: any;
}) => {
	const containerElement = document.getElementById('generic-bulk-upload-service-container');
	if (containerElement.children.length === 0) {
		if (config.data.length > 0) {
			ReactDOM.render(
				<GenericUploadStatusBar
					heading={config.heading}
					batchFunction={config.batchFunction}
					data={config.data}
					failureArrayKeysToShow={config.failureArrayKeysToShow}
					isSingleApi={config.isSingleApi}
					onAllBatchesComplete={config.onAllBatchesComplete}
					dataHeaders={config.dataHeaders}
					onCompletion={() => {
						window.removeEventListener('beforeunload', beforeUnload);
						ReactDOM.unmountComponentAtNode(containerElement);
					}}
				/>,
				containerElement,
			);

			window.addEventListener('beforeunload', beforeUnload);
		} else {
			throw new Error('Data array must have at least one item.');
		}
	} else {
		throw new Error('An upload is already in progress, please wait for it to complete and close the dialog before starting a new one.');
	}
};

export const GenericBulkUploadService = {
	uploadData,
};
